import { render } from "./RemoteWorkDetails.vue?vue&type=template&id=150aea46&scoped=true"
import script from "./RemoteWorkDetails.vue?vue&type=script&lang=js"
export * from "./RemoteWorkDetails.vue?vue&type=script&lang=js"

import "./RemoteWorkDetails.vue?vue&type=style&index=0&id=150aea46&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150aea46"]])

export default __exports__